define(function() {
  const IpsModel = require('civicsBase/ipsModel');
  const ViewManager = require('civicsUtils/view_manager');
  const attachment_utilities = require('civicsUtils/attachment_utility');

  return IpsModel.extend({
    urlRoot: function() {
      var url = "/delegate/civics-api/api";

      if (!ViewManager.versionRange('8.6.0.0')) {
        url += "/core/attachments";
      }


      return url;
    },
    parse: function (response) {
      if (response.data) {
        attachment_utilities.parseVirusScanStatus(response.data);
        if (response.data.data) {
          for (var key in response.data.data) {
            this.attachmentId = key;
            this.fileName = response.data.data[key];
            break;
          }
        }
      }
      return response;
    },
    url: function() {
      var url = this.urlRoot();

      //Add on Request values if we are doing a save.
      if (this.isSave && this.isSave === true) {

        if (ViewManager.versionRange('8.6.0.0', '8.8.0.0')) {
          url += '/core/attachments' +
            '/' + this.attributes.catalog +
            '/' + this.attributes.parentMoniker +
            '/' + this.attributes.parentPrimaryKey;
        } else if (ViewManager.versionRange('8.8.0.0')) {
          if (this.attributes.id) {
            url += '/core/attachments' +
              '/' + this.attributes.parentMoniker +
              '/' + this.attributes.parentPrimaryKey +
              '/' + this.attributes.id
          } else {
            url += '/core/attachments' +
              '/' + this.encodeComponent(this.attributes.provider) +
              '/' + this.attributes.parentMoniker +
              '/' + this.attributes.parentPrimaryKey
          }
        }


        if (!ViewManager.versionRange('8.8.0.0')) {
          //set url parameters
          url += '?';
          //Catalog is required so we can assume the ? above and & for all others
          if (this.attributes.catalog && this.attributes.catalog.length > 0) {
            url += 'Catalog=' + this.encodeComponent(this.attributes.catalog);
          }
          //File name should also be required since we are sending a byte[] that doesn't contain the file Contents file name
          if (this.attributes.fileName && this.attributes.fileName.length > 0) {
            url += '&FileName=' + this.escapeWithoutQuotes(this.attributes.fileName);
          }
          if (this.attributes.title && this.attributes.title.length > 0) {
            url += '&Title=' + this.escapeWithoutQuotes(this.attributes.title);
          }

          if (this.attributes.description && this.attributes.description.length > 0) {
            url += '&Description=' + this.escapeWithoutQuotes(this.attributes.description);
          }
        } else if (ViewManager.versionRange('8.8.0.0')) {

          //ADD
          if (typeof this.attributes.id === 'undefined') {
            //set url parameters
            url += '?';
            if (this.attributes.provider && this.attributes.provider.length > 0) {
              url += 'Provider=' + this.encodeComponent(this.attributes.provider);
            }

            if (this.attributes.fileName && this.attributes.fileName.length > 0) {
              url += '&FileName=' + this.escapeWithoutQuotes(this.attributes.fileName);
            }
            if (this.attributes.title && this.attributes.title.length > 0) {
              url += '&Title=' + this.escapeWithoutQuotes(this.attributes.title);
            }

            if (this.attributes.description && this.attributes.description.length > 0) {
              url += '&Description=' + this.escapeWithoutQuotes(this.attributes.description);
            }

            if (this.attributes.documentType) {
              var documentTypeString = JSON.stringify(this.attributes.documentType);
              documentTypeString = documentTypeString.replace(/"/g, '');
              url += '&documentType=' + documentTypeString;
            }

            if( this.attributes.accountId ){
              url += '&AccountId=' + this.attributes.accountId;
            }
          } else {
            //UPDATE
            if( this.attributes.accountId ){
              url += '?AccountId=' + this.attributes.accountId;
            }
          }          
        }

      } else if (this.isDelete && this.isDelete === true) {
        if (ViewManager.versionRange('8.8.0.0')) {
          url += '/core/attachments' +
            '/' + this.attributes.parentMoniker +
            '/' + this.attributes.parentPrimaryKey +
            '/' + this.attributes.id;

          if( this.attributes.accountId ){
            url += '?AccountId=' + this.attributes.accountId;
          }
        }
      } else {
        url += '/' + this.id;
      }

      return url;
    },
    escapeWithoutQuotes: function(str) {
      if (str === undefined || str === null) return null;
      if (str === '') return '""';

      if (str.indexOf('"')) {
        str = str.replace(/"/g, '""');
      }

      return encodeURIComponent(str);
    },
    sync: function(method, model, options) {
      // Post data as FormData object on create to allow file upload
      if (method == 'create') {
        var formData = new FormData();

        formData.append("file", model.attributes["file"]);
        // Set processData and contentType to false so data is sent as FormData
        _.defaults(options || (options = {}), {
          data: formData,
          processData: false,
          contentType: false
        });
      } else if (method === 'delete') {
        if (options.data) {
          // properly formats data for back-end to parse
          options.data = JSON.stringify(options.data);
        }
        // transform all delete requests to application/json
        options.contentType = 'application/json';
      }

      return Backbone.sync.call(this, method, model, options);
    },
  });
});
